import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './pages/home/home.component';
import {
  CheckoutComponent,
  ContactHeroBannerComponent,
  FeaturedServicesComponent,
  FormComponent,
  GReviewsSectionComponent,
  HeroBannerComponent,
  HowItWorksComponent,
  PostcodeCheckComponent,
  WhyUsSectionComponent,
  OrderSummaryComponent,
  ModalComponent,
  FeaturedV2Component,
} from '@adminprodigydesign/axis';
import { CheckoutPageComponent } from './pages/checkout-page/checkout-page.component';

import { OrderSummaryPageComponent } from './pages/order-summary-page/order-summary-page.component';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentComponent } from './pages/payment/payment.component';
import { ThankYouPageComponent } from './pages/thank-you-page/thank-you-page.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { FeaturesModule } from '../features/features.module';
import { TenantUnavailableComponent } from './pages/tenant-unavailable/tenant-unavailable.component';
import { RouterModule } from '@angular/router';
import { CookiePolicyComponent } from './pages/cookie-policy/cookie-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { MenuComponent } from './pages/menu/menu.component';
import { SharedModule } from '../shared/shared.module';
import { MenuFilterPipe } from '../shared/pipes/menu-filter.pipe';
import { UserModule } from '../features/user/user.module';

@NgModule({
  declarations: [
    HomeComponent,
    CheckoutPageComponent,
    OrderSummaryPageComponent,
    MyAccountComponent,
    PaymentComponent,
    ThankYouPageComponent,
    TenantUnavailableComponent,
    CookiePolicyComponent,
    TermsOfServiceComponent,
    MenuComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HeroBannerComponent,
    FeaturedServicesComponent,
    FeaturedV2Component,
    ContactHeroBannerComponent,
    FormComponent,
    WhyUsSectionComponent,
    GReviewsSectionComponent,
    HowItWorksComponent,
    FormComponent,
    CheckoutComponent,
    PostcodeCheckComponent,
    OrderSummaryComponent,
    ModalComponent,
    GoogleMapsModule,
    FeaturesModule,
    FormsModule,
    RouterModule,
    SharedModule,
    MenuFilterPipe,
    UserModule,
  ],
  exports: [],
})
export class CoreModule {}
